import { useState } from "react";
import { ComplexesTab } from "../components/organisms";
import { useListComplexesUrlQuery } from "../api/complexes/complexes.queries";
import { LoadingBlurDiv } from "@shared/components";
import { ClientSelector } from "../../clients";

const ComplexesPage = () => {
  const [selectedClient, setSelectedClient] = useState<string | null>(null);

  const { query, setFilters, resetFilters, currentFilters } =
    useListComplexesUrlQuery(selectedClient);

  return (
    <>
      <ClientSelector onSelect={setSelectedClient} />
      {selectedClient && (
        <LoadingBlurDiv isLoading={query.isFetching}>
          <ComplexesTab
            tenantId={selectedClient}
            complexes={query.data?.data || []}
            paginatedMeta={query.data?.meta}
            isLoading={query.isFetching}
            onFilter={setFilters}
            onClearFilter={resetFilters}
            initialFilters={currentFilters}
          />
        </LoadingBlurDiv>
      )}
    </>
  );
};

export default ComplexesPage;
